import axios from 'axios';
import { useEffect, useState } from 'react';
import { useAlert } from 'react-alert';
import { Modal, Spinner } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import { FaRupeeSign, FaWhatsapp } from 'react-icons/fa6';
import { Link, useNavigate } from 'react-router-dom';
import { BASE_URL } from '../../../insightConfig/insightConfig';
import '../../../jsx/Dashborad/dashboard.css';
import CivilButton from '../../ReusableComponent/CIVIL/CivilButton/CivilButton';
import SectionII_PaymentModal from './SectionII_PaymentModal';
function SectioII_Home() {
    const navigate = useNavigate();
    const alert = useAlert();

    const [open, setOpen] = useState(false);
    const [openPaymentProccessingModal, setPaymentProccessingModal] = useState(false);
    const email = localStorage.getItem("authtoken")
    const [loadingTests, setLoadingTests] = useState(false);
    // const [testSeriesData, setTestSeriesData] = useState(null);
    const [subjects, setSubjects] = useState([]);
    const [testPlans, setTestPlans] = useState([]);
    const [selectedSubject, setSelectedSubject] = useState({ Sn: 0, SubjectType: 'Please select subject' });
    const [selectedTest, setSelectedTest] = useState({ Sn: 1, TestCount: 5, Price: 500, Discount: 0 });
    const [tests, setTests] = useState([]);
    const [checkedSubjects, setCheckedSubjects] = useState([]);
    console.log(checkedSubjects);
    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                const response1 = await axios.get(BASE_URL + `/cuet/user/subjcts/Section-II`);
                setSubjects(response1.data.data);
                setSelectedSubject(response1.data.data[0]);
                const response2 = await axios.get(BASE_URL + `/cuet/user/testplans/Section-II`);
                setTestPlans(response2?.data?.data);
                setSelectedTest(response2?.data?.data[0]);
            } catch (error) {
                console.log(error);
            }

        }
        fetchInitialData()
    }, []);

    useEffect(() => {
        setCheckedSubjects(subjects.filter(data => data.checked));
        setTests(new Array(selectedTest.TestCount).fill(1));
    }, [subjects]);
    function getPercentage(value, total) {
        return total === 0 ? 0 : (value / total) * 100;
    }



    const price = (checkedSubjects || [])
        .filter(data => typeof data.Price === 'number' && typeof data.Discount === 'number')
        .reduce((acc, curr) => acc + curr.Price, 0);

    const totalPayable = (checkedSubjects || [])
        .filter(data => typeof data.Price === 'number' && typeof data.Discount === 'number')
        .reduce((acc, curr) => acc + (curr.Price - (curr.Price * curr.Discount / 100)), 0);




    const testSeriesPrice = selectedTest?.Price.toLocaleString('en-IN');
    const priceAfterDiscount = selectedTest.Price - (selectedTest.Price * (selectedTest.Discount / 100))
    const payableAmount = Math.ceil(priceAfterDiscount);
    const handleEnroll = () => {
        if (!selectedSubject.Sn) {
            alert.show("Please select SubjectType first");
            return;
        }
        if (email) {
            setOpen(true);
        } else {
            navigate('/login');
        }
    }

    const handleSelectSubject = (subject) => {
        let copy = [...subjects];
        let selectedSubject = copy.find((data) => data.Sn == subject.Sn);
        selectedSubject.checked = !selectedSubject.checked
        setSubjects(copy);

    };
    const handlePlanSelect = (subjectId, plan) => {
        let copy = [...subjects];
        let selectedSubject = copy.find((data) => data.Sn === subjectId);

        if (!selectedSubject.checked) return; // prevent change if subject not checked

        selectedSubject.TestCount = plan.TestCount;
        selectedSubject.Price = plan.Price;
        selectedSubject.Discount = plan.Discount;

        setSubjects(copy);
    };

    return (
        <>
            <Helmet>
                <title>{"CUET|Seciton-IA"}</title>
                {/* <meta name="description" content={`${testSeriesData.MetaDescription}`}></meta> */}
            </Helmet>
            {/* Civil Test Page Start */}
            <div className='Dashboard-background'>
                <div className='container-fluid'>
                    <div className='row'>
                        <div className='col-lg-6 col-md-12 col-sm-12 dashboardmain-left p-3'>
                            <div className='dashboardleft-background'>
                                <div className='dash2'>
                                    <div className="d-grid gap-2">
                                        <table className="table table-striped table-bordered table-hover text-center align-middle shadow-sm w-100">
                                            <thead className="table-primary">
                                                <tr>
                                                    <th style={{ width: '10%' }}>Select</th>
                                                    <th style={{ width: '30%' }}>Item Name</th>
                                                    <th colSpan={testPlans.length || "4"}>Select Number of Tests</th>
                                                </tr>
                                                <tr className="table-light">
                                                    <th></th>
                                                    <th></th>
                                                    {testPlans.map(test => (
                                                        <th key={test.TestCount} /* style={{ width: '15%' }} */>
                                                            {test.TestCount} {/* {num > 1 ? 's' : ''} */}
                                                        </th>
                                                    ))}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {subjects?.map((subject, index) => (
                                                    <tr key={subject.Sn} className={index % 2 === 0 ? 'table-white' : 'table-light'}>
                                                        <td>
                                                            <div className="d-flex justify-content-center">
                                                                <input
                                                                    type="checkbox"
                                                                    className="form-check-input"
                                                                    style={{ transform: 'scale(1.5)', cursor: 'pointer' }}
                                                                    checked={subject.checked}
                                                                    onChange={() => handleSelectSubject(subject)}
                                                                />
                                                            </div>
                                                        </td>
                                                        <td className="text-start fw-semibold">{subject?.SubjectType}</td>
                                                        {testPlans?.map(plan => (
                                                            <td key={plan.Sn}>
                                                                <div className="d-flex justify-content-center">
                                                                    {/* <input
                                                                        type="checkbox"
                                                                        className="form-check-input"
                                                                        style={{ transform: 'scale(1.5)', cursor: 'pointer' }}
                                                                        checked={subject.checked && subject.TestCount === plan.TestCount}
                                                                        onChange={() => handlePlanSelect(subject.Sn, plan)}
                                                                    /> */}
                                                                    <input
                                                                        type="checkbox"
                                                                        className="form-check-input"
                                                                        style={{ transform: 'scale(1.5)', cursor: 'pointer' }}
                                                                        disabled={!subject.checked}
                                                                        checked={subject.checked && subject.TestCount === plan.TestCount}
                                                                        onChange={() => handlePlanSelect(subject.Sn, plan)}
                                                                    />

                                                                </div>
                                                            </td>
                                                        ))}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>






                                        {
                                            selectedTest.Sn && selectedSubject.Sn ?
                                                <>
                                                    <button style={{
                                                        pointerEvents: price > 0 ? 'auto' : 'none',
                                                        cursor: price > 0 ? 'pointer' : 'not-allowed',
                                                    }}
                                                        onClick={handleEnroll} className="btn btn-orange py-2" type="button">
                                                        <h6 className='text-decoration-line-through'>FEE <FaRupeeSign className='fs-6' /> {price}</h6>
                                                        <h6 className=''>PAY JUST <FaRupeeSign className='fs-6' /> {totalPayable?.toLocaleString('en-IN')}</h6>
                                                        <hr className='my-1' />
                                                        {/* <h6 className=''>DISCOUNT {selectedTest.Discount}%</h6> */}
                                                    </button>
                                                    {/* <button className="btn btn-orange py-3" onClick={handleEnroll} type="button"><FaRupeeSign className='fs-6' /> {totalPayable?.toLocaleString('en-IN')} {totalPayable < 1 ? 'ENROLL FOR FREE' : 'ENROLL'}</button> */}
                                                </> : null
                                            // <button className="btn btn-orange py-3" type="button">ENROLLED</button>
                                        }

                                        <Link to="https://api.whatsapp.com/send?phone=91981833320" target='_blank' className="btn d-flex align-item-center justify-content-center bg-darkgreen fw-bold py-3" type="button"><FaWhatsapp className='me-1 fs-5' /> WHATSAPP 9818333201</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-6 col-md-12 col-sm-12'>
                            <CivilButton componentName="CUET_Section_II" ExamType='Section-II' CUET_Tests={tests} loadingCUETTests={loadingTests} SectionII_Subjects={checkedSubjects} />
                            {/* <CivilButton setOpenPaymentModal={setOpen} testSeriesData={testSeriesData} componentName={componentName} authtoken={storedAuthToken} /> */}
                        </div>
                    </div>
                </div>
            </div>
            <Modal show={open} centered className="animate__animated animate__fadeIn mobileyoutube">
                <SectionII_PaymentModal setOpen={setOpen} Amount={payableAmount} ExamType="Section-II" TestCount={selectedTest.TestCount} orders={checkedSubjects?.filter(data => data.checked && data.Price)} setPaymentProccessingModal={setPaymentProccessingModal} />
            </Modal>
            <Modal show={openPaymentProccessingModal} top backdrop="static" dialogClassName="custom-modal-width">
                <div className="modal-content" style={{ backgroundColor: "#f0f8ff", padding: "2rem", borderRadius: "10px" }}>
                    <div className="modal-body" style={{ padding: "2rem" }}>
                        <div className="mb-3 d-block text-center">
                            <Spinner
                                animation="border"
                                className="mt-5 mb-3"
                                size="xl"
                                style={{ width: "200px", height: "200px", color: "#ff2f00" }}

                            />
                            <h5
                                className="modal-title mb-5"
                                id="exampleModalLabel"
                                style={{ color: "#17a2b8", fontFamily: "Arial, sans-serif" }}
                            >
                                Saving Order Details. This may take a moment...
                            </h5>
                        </div>
                    </div>
                </div>
            </Modal>
            {/* Civil Test Page End */}
        </>
    )
}

export default SectioII_Home;
